import React, { useEffect, useState } from "react";
import { Tabs, Table, Button, IconDownload, Select,  IconPlus, InlineNotification, FilePicker, AlertModal } from "@veneer/core";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import moment from "moment";
import { currencyFormat } from "./../../../common/js/utils/numberFormat";
import XLSX from "xlsx";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { downloadFile } from "../../../services/FileDownloader/FileDownloader";
import $ from 'jquery';

const PriceListbrazil= (props)=> {
  const { id } = props.match.params;
  const connectApi = new ConnectAPI();
  const { t, i18n } = useTranslation();
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const [loadingData, setLoadingData] = useState(false);
  
  const [pricelist, setpricelist]=useState([]);
  const [pageSize, setPageSize] = useState(15);
  const [dateselect, setdateselect] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [month, setmonth]=useState([]);
  const handlePageChange = (page) => setCurrentPage(page);
  const selectTab = () => (index) => {
      setactiveTabIndex(index);
  };
  function sort(array, orderBy, orderType) { 
    return array.sort((a, b) => {
      const value = (orderType === 'descending')
        ? descendingComparator(a, b, orderBy)
        : -descendingComparator(a, b, orderBy);
  
      return value;
    });
  }
  function filter(array, filters) {
    let arrayFiltered = array;
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();
          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });
    return arrayFiltered;
  }
  function descendingComparator(a, b, orderBy) {
    const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
    const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
    
    
    if(orderBy=="startDate" || orderBy=='endDate'){
      if (Date.parse(bSort) < Date.parse(aSort)) {
        return -1;
      }
      if (Date.parse(bSort) > Date.parse(aSort)) {
        return 1;
      }
    }else{
      if (bSort < aSort) {
        return -1;
      }
      if (bSort > aSort) {
        return 1;
      }
    }
    
    return 0;
  }
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  const fetchPrices=()=>{
      connectApi.get("api/Channels/getpricesbrazil",'', priceResponse)
      .catch ((error) => {
        Swal.fire(
            "Error " + error?.response?.status,
            error?.response?.data,
            "error"
        );
      });
  }
  const priceResponse = (status, data) => {
    var filter=data.map(item=>item.startDate).filter(onlyUnique);
    var dates = [];
    filter.forEach(element => {
      setmonth(element);
      dates.push( { value: element.toString() , label: moment(element).format('MMMM-YYYY').toString() });
    });
    setdateselect(dates);
    setpricelist(data);
  };

  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    fetchPrices();
  }, [id]);
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'css-la566w-padding-Button',
      cancelButton: 'css-k95t6a-padding-Button'
    },
    buttonsStyling: true
  })
  const Pricelist=()=>{
    const ConfigColumns = [
      {
        id: 'idPart',
        label: 'id Part',
      },
      {
        id: 'typeConsumable',
        label: 'Type Consumable',
        
      },
      {
        id: 'description',
        label: 'Description',
      },
      {
        id: 'price',
        label: 'Price'
      },
      {
        id:'invoicelocal', 
        label:'Danfe Price'
      },
      {
        id: 'startDate',
        label: 'startDate'
      },
      {
        id:'endDate',
        label:'endDate'
      },
      {
        id:'dateUpdate',
        label:'Date Update'
      },
      {
        id:'updateBy',
        label:'Update By'
      }
    ]
    const [orderBy, setOrderBy] = useState('idpart');
    const [orderType, setOrderType] = useState('ascending');
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };
    let filteredData=filter(pricelist,
      {
        startDate:month
      }
    );
    let pagdata=sort(filteredData, orderBy, orderType).slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    const handleSelectMonth = (name) => (event) => {
        setmonth(event.value);
    };
    const handleClearMonth = (name) => (event) => {
      setmonth();
    };
    return (
      <>
        <Row>
          <Col xs="2" md="2">
            <Select
              options={dateselect}
              id="select-usage"
              label="Select"
              value={[month]}
              onClear={handleClearMonth()}
              onChange={handleSelectMonth()}
            />
          </Col>
        </Row>
        <Table id='SpecialConditionsActive'
          columns={[
            {
              id: 'idPart',
              label: 'idPart',
            },
            {
              id: 'typeConsumable',
              label: 'Type Consumable',
            },
            {
              id: 'description',
              label: 'Description',
            },
            {
              id: 'price',
              label: 'Price'
            },
            {
              id:'invoicelocal', 
              label:'Danfe Price'
            },
            {
              id: 'startDate',
              label: 'startDate'
            },
            {
              id: 'endDate',
              label: 'endDate'
            },
            {
              id:'dateUpdate',
              label:'dateUpdate'
            },
            {
              id:'updateBy',
              label:'updateBy'
            }
          ]}
          data={pagdata}
          showFilters
          onColumnReorder={handleOnColumnReorder}
          columnReorder
          onSort={handleSort}
          preferences={{
            defaultOrder: ConfigColumns.map((c) => c.idpart),
            order,
            sortBy: {
              id: orderBy,
              type: orderType,
            },
            
           
          }}
          pagination={{
            currentPage,
            onPageChange: handlePageChange,
            pageSize,
            totalItems: filteredData.length,
          }}
        />
        <Button
          onClick={()=>{

            setTimeout(() => {
              let data=filteredData;
              let headerEndUsers = [
                'idPart',
                'typeConsumable',
                'description',
                'price',
                'monthyear',
                'dateUpdate',
                'updateBy'
              ];
              const dataXlsx = data.map((item) => {
                return item;
              });
              const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
              const wb = XLSX.utils.book_new();
              const date = moment(new Date()).format('YYYYMMDDHHmm');
              const filename = 'PricelistBrazil-' + date + '.xlsx';
              const ws_name = "PricelistBrazil";
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              XLSX.writeFile(wb, filename);
            }, 750);

          }}
          disabled={filteredData.length === 0}
          leadingIcon={<IconDownload />}
            title={t('download data')}
           
          >
            {t('download')}
          </Button>
      </>
    );
  }
  const UploadPrice=()=>{
        const [showNotification, setShowNotification] = useState(false);
        const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
        const [file, setFile]=useState(null);
        const [submit, setSubmit] = useState(false);

        function handleChange(event) {
            setFile(event.target.files[0])
        }
        function submitFile(){
            setSubmit(true);
            let data = new FormData();
            data.append("Action","FileDate");
            data.append("file", file);
            data.append("confirm","");
            connectApi.post(
                "api/Channels/uploadpricebrazil",
                data,
                handleReloadData
            ).catch((error) => {
                if (error?.response?.status==506){
                    setSubmit(false);
                    swalWithBootstrapButtons.fire({
                        title: "Warning " + error?.response?.status,
                        html: t("Confirm_brazil")+", "+error?.response?.data,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Upload file',
                        cancelButtonText:'Return and change file',
                      }).then((result) => {
                        if (result.isConfirmed) {
                            data.delete("confirm");
                            data.append("confirm","yes");
                            setSubmit(true);
                            connectApi
                            .post(
                                "api/Channels/uploadpricebrazil",
                                data,
                                handleReloadData
                            ).catch((error) => {
                              if(error?.response.status==500){
                                setSubmit(false);
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: error?.response.data,
                                });
                              }
                            })
    
                        }
                      })
                }else if (error?.response?.status==505){
                    setSubmit(false);
                    Swal.fire(
                        "Error " ,
                        "Invalid file or structure",
                        "error"
                    );
                }else{
                    setSubmit(false);
                    Swal.fire(
                        "Error " ,
                        error?.response?.data,
                        "error"
                    );
                }
                
            });
        }
        const handleReloadData = (status,data) => {
            setSubmit(false);
            if (status==200){
                setNotificationDetails({
                    title: t("notifyAllCorrect"),
                    type: 'positive',
                    description: ''
                });
                window.location.reload();
            }else if(status==505){

            }else if(status==506){

            }else{
                Swal.fire(
                    "Error " + data.status,
                    data.data,
                    "error"
                );
                setNotificationDetails({
                    title: t("notifyWrognSQL"),
                    type: 'negative',
                    description: t("notifySQLError")
                });
            }
            setSubmit(false);
            setShowNotification(true);
        }

        return(
            <div>
                {submit? (
                    <AlertModal
                        id="alert-modal"
                        onClose={() => setSubmit(false)}
                        show={submit}
                        title={t("upload")}
                    >
                        <Button
                            expanded={true}
                            loading
                            appearance="tertiary"
                        />
                    </AlertModal>
                ):("")}
                <Row>
                    <Col 
                        style={{
                            position: "absolute",
                            marginTop: "15px",
                        }}
                    >
                        <div 
                            style={{
                                marginLeft: "30%",
                                width: "250px",
                            }}
                        >
                            <FilePicker 
                                id="Files"
                                accept=".xlsx,.xls,.csv"
                                onChange={handleChange}
                            />
                            <Button 
                                style={{
                                    position: "absolute",
                                    height: "35px",
                                    width: "50px",
                                    marginLeft: "252px",
                                    marginTop: "-35px"
                                }}
                                appearance="secondary" 
                                leadingIcon={<IconDownload />} 
                                onClick={() => {downloadFile("template_brazil.xlsx");}}
                            >
                              </Button>
                            <Button 
                                style={{
                                    marginTop: "8px",
                                }}
                                appearance="secondary" 
                                leadingIcon={<IconPlus size={30} filled />}
                                onClick={submitFile}
                                loading={submit}
                               
                            >
                              Upload
                            </Button>
                        </div>
                    </Col>
                </Row>
                <div style={{marginTop: "75px", width: "300px", marginLeft:"30%"}}> <br /><br />
                    {showNotification ? (
                        <div className="show-animated" style={{ marginBottom: '-12px' }}>
                            <InlineNotification
                                title={notificationDetails.title}
                                type={notificationDetails.type}
                                description={notificationDetails.description}
                                onClose={() => { setShowNotification(false) }}
                            /> <br />
                        </div>
                    ) : undefined}
                    
                </div>
            </div>
        );
  }
  return (<>
   <Tabs
    controlId="default"
    onChangeTab={selectTab()}
    selectedTabId={activeTabIndex}
      tabs={[
        { id: 0, label: 'Price List', content: <div style={{ padding: '30px' }}><Pricelist/></div> },
        { id: 1, label: 'Upload Price List', content: <div style={{ padding: '30px' }}><UploadPrice/></div> },
      ]}
    />
  </>
  );
};

export default PriceListbrazil;
